import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import {
  CountryOption,
  getCountryOptions,
  normalizeCountryCode,
  normalizePhoneNumber,
} from '../../../shared/profile-contact.util';

@Component({
  selector: 'app-ajustes',
  templateUrl: './ajustes.component.html',
  styleUrls: ['./ajustes.component.css'],
})
export class AjustesComponent implements OnInit {
  user: any;
  nombres: string;
  apellidos: string;
  email: string;
  codigo: string;
  telefono: string;
  fechanac: any;
  genero: string;
  pais: string;
  avatar: string;
  uid: string;
  uid_in_userdatabase: any;
  saveresponse: string;
  currentuid: string;
  countryOptions: CountryOption[] = [];
  responseType: 'success' | 'error' | '' = '';

  alerta: boolean = false;
  guardado: boolean = false;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private datepipe: DatePipe,
    private translate: TranslateService
  ) {}

  private getUserName(user: any): string {
    return user?.name || user?.nombres || '';
  }

  private getUserLastName(user: any): string {
    return user?.last_name || user?.apellidos || '';
  }

  private getUserGender(user: any): string {
    return user?.gender || user?.genero || '';
  }

  private getUserCountry(user: any): string {
    return user?.country || user?.pais || '';
  }

  private getUserCode(user: any): string {
    return user?.code || user?.codigo || '';
  }

  private getUserPhone(user: any): string {
    return user?.phone_number || user?.phone || user?.telefono || '';
  }

  private titleCaseValue(value: any): string {
    const text = value ? String(value) : '';
    return text ? text[0].toUpperCase() + text.substr(1).toLowerCase() : '';
  }

  private parseDate(value: any): Date | null {
    if (!value) return null;
    if (value.seconds !== undefined) return new Date(value.seconds * 1000);
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  private setError(translationKey: string): void {
    this.translate.get(translationKey).subscribe((data) => {
      this.guardado = false;
      this.alerta = true;
      this.responseType = 'error';
      this.saveresponse = data;
      setTimeout(() => {
        this.saveresponse = '';
        this.alerta = false;
        this.responseType = '';
      }, 3000);
    });
  }

  private setSuccess(translationKey: string): void {
    this.translate.get(translationKey).subscribe((data) => {
      this.alerta = false;
      this.guardado = true;
      this.responseType = 'success';
      this.saveresponse = data;
      setTimeout(() => {
        this.saveresponse = '';
        this.guardado = false;
        this.responseType = '';
      }, 3000);
    });
  }

  private loadCountryOptions(): void {
    const language = this.translate.currentLang || this.translate.getDefaultLang() || 'es';
    this.countryOptions = getCountryOptions(language);
  }

  private loadUser(user: any, uidInDatabase: string, currentUid: string): void {
    this.user = user;
    this.uid_in_userdatabase = uidInDatabase;
    this.uid = currentUid;
    this.nombres = this.titleCaseValue(this.getUserName(user));
    this.apellidos = this.titleCaseValue(this.getUserLastName(user));
    this.email = user?.email || '';
    this.codigo = this.getUserCode(user);
    this.telefono = this.getUserPhone(user);
    const birthDate = this.parseDate(user?.date_of_birth || user?.birth_date || user?.fechanac);
    this.fechanac = birthDate ? this.datepipe.transform(birthDate, 'yyyy-MM-dd') : '';
    this.genero = this.titleCaseValue(this.getUserGender(user));
    this.pais = normalizeCountryCode(this.getUserCountry(user));
    this.avatar = user?.avatar || '';
  }

  ngOnInit(): void {
    this.loadCountryOptions();
    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.authenticationService.getStatus().subscribe((status) => {
        this.currentuid = status.uid;

        this.userService.getUserById(this.currentuid).subscribe(
          (data) => {
            if (data[0]) {
              this.loadUser(data[0].payload.doc.data(), data[0].payload.doc.id, this.currentuid);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
    } else {
      this.currentuid = Userdata.payload.doc.data().uid;
      this.loadUser(Userdata.payload.doc.data(), Userdata.payload.doc.id, this.currentuid);
    }
  }

  saveSettings() {
    this.guardado = false;
    this.alerta = false;
    this.responseType = '';
    this.saveresponse = '';
    const normalizedPhone = normalizePhoneNumber(this.telefono);
    const normalizedCountry = normalizeCountryCode(this.pais);

    if ((this.telefono || '').trim() && !normalizedPhone) {
      this.setError('dashboard.perfil.ajustesopt.telefonoInvalido');
      return;
    }

    if ((this.pais || '').trim() && !normalizedCountry) {
      this.setError('dashboard.perfil.ajustesopt.paisInvalido');
      return;
    }

    const theuser = {
      uid: this.uid,
      code: (this.codigo || '').toLowerCase(),
      phone_number: normalizedPhone || null,
      date_of_birth: this.fechanac ? new Date(this.fechanac + ' 00:00') : null,
      gender: (this.genero || '').toLowerCase(),
      country: normalizedCountry || null,
    };

    this.userService
      .editUser(theuser, this.uid_in_userdatabase)
      .then(() => {
        this.telefono = normalizedPhone || '';
        this.pais = normalizedCountry || '';
        this.user = {
          ...this.user,
          ...theuser,
          uid: this.uid,
          phone_number: normalizedPhone || null,
          telefono: normalizedPhone || null,
          country: normalizedCountry || null,
          pais: normalizedCountry || null,
        };
        this.userService.mergeUserinfo(this.user);
        this.setSuccess('dashboard.perfil.ajustesopt.guardado');
      })
      .catch(() => {
        this.translate
          .get('dashboard.perfil.ajustesopt.error')
          .subscribe((data) => {
            this.guardado = false;
            this.alerta = true;
            this.responseType = 'error';
            this.saveresponse = data;
            setTimeout(() => {
              this.saveresponse = '';
              this.alerta = false;
              this.responseType = '';
            }, 2200);
          });

        setTimeout(() => {
          this.saveresponse = '';
        }, 2200);
      });
  }
}
